import { observable } from "mobx";

/**
 * QAEventInfo defines event for racing braches.
 *
 * @typedef Fixture
 * @type {Object}
 * @property {top} top text of the fixture
 * @property {bottom} bottom text of the fixture
 */

export class Fixture {
    @observable top: string;
    @observable bottom?: string;

    constructor(source: Fixture) {
        this.top = source.top;
        this.bottom = source.bottom;
    }
}